import axios from 'axios';
import * as gravityInterceptor from '@/modules/interceptors/gravityInterceptor';

const REQ_TIMEOUT = 5000;
const defaultErrorHandler = (error: any) => Promise.reject(error);

const cfInstance = axios.create({
  baseURL: process.env.GRAVITY_API_URL_CF,
  timeout: REQ_TIMEOUT,
});

cfInstance.interceptors.request.use(gravityInterceptor.requestSuccess, defaultErrorHandler);

export {
  cfInstance,
};
